import GridLayout, { Layout } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import { PageComponent } from "../types/components";

interface PageGridProps {
  components: PageComponent[];
  gridKey?: string;
  cols?: number;
  rowHeight?: number;
  width: number;
  height: number;
  isDraggable?: boolean;
  isResizable?: boolean;
  onLayoutChange?: (layout: Layout[]) => void;
  draggableHandle?: string;
  children: (component: PageComponent) => React.ReactNode;
  emptyState?: React.ReactNode;
}

export default function PageGrid({
  components,
  gridKey,
  cols = 48,
  rowHeight,
  width,
  height,
  isDraggable = false,
  isResizable = false,
  onLayoutChange,
  draggableHandle,
  children,
  emptyState,
}: PageGridProps) {
  // Calcula rowHeight proporcionalmente à altura para manter as proporções do layout
  // Baseline: 800px de altura = 10px de rowHeight (80 linhas)
  // Escala proporcionalmente: se altura dobra, rowHeight dobra também
  const baseHeight = 800;
  const baseRowHeight = 10;
  const responsiveRowHeight = rowHeight || (baseRowHeight * height) / baseHeight;

  const getGridLayout = (): Layout[] => {
    return components.map((component) => ({
      i: component.id,
      x: component.position.x,
      y: component.position.y,
      w: component.position.w,
      h: component.position.h,
    }));
  };

  if (components.length === 0 && emptyState) {
    return <>{emptyState}</>;
  }

  return (
    <GridLayout
      key={`grid-${gridKey || "default"}-${width}`}
      className="layout"
      layout={getGridLayout()}
      cols={cols}
      rowHeight={responsiveRowHeight}
      width={width}
      onLayoutChange={onLayoutChange}
      isDraggable={isDraggable}
      isResizable={isResizable}
      compactType="vertical"
      preventCollision={false}
      margin={[24, 24]}
      draggableHandle={draggableHandle}
      useCSSTransforms={true}
    >
      {components.map((component) => (
        <div key={component.id} className="h-full">
          {children(component)}
        </div>
      ))}
    </GridLayout>
  );
}
